import { useEffect, useState } from 'react';
import Papa from 'papaparse';

export const useEducationalOffer = () => {
    const [programs, setPrograms] = useState([]);
    const [loadingPrograms, setLoadingPrograms] = useState(false);
    const [errorPrograms, setErrorPrograms] = useState(null);

    useEffect(() => {
        const fetchPrograms = async () => {
            setLoadingPrograms(true);
            try {
                const url =
                    'https://docs.google.com/spreadsheets/d/1tudjK38el20Ou9Pdxpc7_13k12WFzAyRCvSxeJN2i3Y/gviz/tq?gid=0&tq=select+A,C,D,E+where+H+matches+%27.*posgrados.*%27+and+G+%3C%3E+%27x%27&tqx=reqId:1;out:csv';
                const response = await fetch(url);
                const reader = response.body.getReader();
                const result = await reader.read();
                const decoder = new TextDecoder('utf-8');
                const csvData = decoder.decode(result.value);
                const parsedData = Papa.parse(csvData, {
                    header: false,
                }).data;
                const programsWithHeaders = parsedData.map((row) => ({
                    productId: row[0],
                    categoryProduct: row[1],
                    productTitle: row[2] + ' ' + row[3],
                }));
                setPrograms(programsWithHeaders);
            } catch (error) {
                setErrorPrograms(`Ha ocurrido un error: ${error}`);
            } finally {
                setLoadingPrograms(false);
            }
        };

        fetchPrograms();
    }, []);

    return { programs, loadingPrograms, errorPrograms };
};
